import { render, staticRenderFns } from "./GestionInfoInspeccionesHidrocarburos.vue?vue&type=template&id=8bfd6144"
import script from "./GestionInfoInspeccionesHidrocarburos.vue?vue&type=script&lang=js"
export * from "./GestionInfoInspeccionesHidrocarburos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports